import m = require("mithril");
import {Vnode, VnodeDOM} from "mithril";

export class ImagePreview  {

    private element?: VnodeDOM;
    private size = 'fit';
    private showMagnify = false;

    constructor(
        public url: string,
        public cbHide: ()=>void,
    ) {
    }


    private onClickImage(e: MouseEvent) {
        if (this.size === 'full') {
            return;
        }

        if (this.isImageBiggerThanScreen()) {
            e.stopPropagation();
            this.size = 'full';
        }
    }

    private isImageBiggerThanScreen(): boolean {
        if (this.element) {
            const img = <HTMLImageElement>$(this.element.dom).find('img')[0];
            return img.naturalWidth > window.innerWidth || img.naturalHeight > window.innerHeight;
        }
        return false;
    }

    public view(): Vnode {
        return m('div.imagePreview.'+this.size, {
            oncreate: (vnode) => {
                this.element = vnode
            },
            onclick: () => this.cbHide(),
        }, [
            m('div.imagePreviewContent', [
                m('img'+((this.showMagnify && this.size === 'fit')?'.magnify':''), {
                    src: this.url,
                    onclick: this.onClickImage.bind(this),
                    onmouseenter: () => {
                        this.showMagnify = this.isImageBiggerThanScreen();
                    }
                }
            )]),
            m('div.imagePreviewClose', {}, [
                m('.icon.icon-close.danger')
            ])
        ]);
    }
}